<template>
  <div class="home-container">

    <el-card class="el-card-d" shadow="always">
      <p class="p2">留言给我们</p>
      <div class="infinite-list-wrapper" style="overflow:auto;">

        <el-timeline
            infinite-scroll-disabled="disabled">
          <div v-if="allmessages.length>0">
            <el-timeline-item v-for="(item,index) in allmessages"  :key="index" :timestamp='item.createtime' placement="top">
              <el-card class="el-card-m" style="height:120px">
                <h4>{{item.membername}}：</h4>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}</p>
              </el-card>
            </el-timeline-item>
          </div>
          <div v-else>
            <el-timeline-item placement="top">
              <el-card class="el-card-m" style="height:120px">
                <h4>大黄子：</h4>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 说点什么吧😁</p>
              </el-card>
            </el-timeline-item>
          </div>
        </el-timeline>
      </div>
      <div class="el-card-messages">
        <el-input type="textarea" :rows="5" placeholder="输入留言" maxlength="200" v-model="message"></el-input>
        <el-button type="info" round class="submit-message" @click="submitMessage">留言</el-button>
      </div>

    </el-card>

  </div>
</template>

<script>

export default {
  name: "About",
  data() {
    return {
      form: {},
      message:'',
      allmessages:[]
    }
  },
  created() {
    this.load()
  },
  methods:{
    submitMessage(){
      if(this.message=='' || this.message.replace(/(^\s*)|(\s*$)/g, "")==""){
        this.$message('写点啥提交也行呀😉');
        return;
      }//  这里往下写调用后端的代码
      this.request.post("/message", { "content": this.message }).then(res => {
        if (res.code === '200') {
          this.$message.success("保存成功")
          this.dialogFormVisible = false
          this.load()
        } else {
          this.$message.error(res.msg)
        }
      })
      },

    load(){
      this.request.get('/message').then(res=>{
        this.allmessages = res.data/*.map(item=>item.messages)*/
      })
    }
  },
};
</script>

<style lang="scss">
.infinite-list-wrapper{
  width: 100%;
  height: 500px;
}
.submit-message{
  width: 100%;
  background: rgb(235, 245, 247);
  color: cadetblue;
  letter-spacing:20px;
}
@media screen and (max-width: 3000px) and (min-width: 767px) {
  .el-card-d{
    float: left;
    margin-top: 20px;
    margin-left: 10%;
    width: 80%;
    height: 90%;
  }

}
/*
屏幕小于768px的
*/
@media screen and (max-width:768px) and (min-width: 100px){
  .el-card-d{

    width: 100%;
    height: 100%;
  }
}

.home-container {
  padding-top: 0;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  width: 50%; /* 或者具体的像素值 */
}
.p {
  color: #666666;
  font-family: Serif;
  font-size: 17px;
  margin-bottom: 20px;
  padding-left: 15%;  /* 设置左内边距为父元素宽度的10% */
  padding-right: 15%; /* 设置右内边距为父元素宽度的10% */
}
.p2 {
  font-family: Serif;
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
  color: #666666;
}
.ttl-te {
  font-family: Serif;
  font-size: 25px;
  padding-left: 15%;
  font-weight: bold;
  color: #000000;
}
.ttl {
  font-family: serif;
  font-size: 25px;
  padding-left: 15%;

  color: #000000;
}
</style>